import { showError, showSuccess } from '@calendly/alert'
import { I18n } from '@calendly/i18n'

import { rootApi } from 'root-api'

import { ORGANIZATION_TERMS_STATUS_TAG } from './constants'

const api = rootApi.enhanceEndpoints({ addTagTypes: [ORGANIZATION_TERMS_STATUS_TAG.type] }).injectEndpoints({
  endpoints: (build) => ({
    fetchOrgTermsStatus: build.query({
      query: () => ({
        url: '/api/organization/legal_agreements/terms_of_use',
        method: 'GET',
      }),
      providesTags: [ORGANIZATION_TERMS_STATUS_TAG],
    }),
    recordTermsExposure: build.mutation({
      query: () => ({
        url: '/api/organization/legal_agreements/terms_of_use/exposure',
        method: 'POST',
      }),
      extraOptions: { handleErrors: false },
      invalidatesTags: (_, error) => (error ? [] : [ORGANIZATION_TERMS_STATUS_TAG]),
    }),
    acceptTerms: build.mutation({
      query: () => ({
        url: '/api/organization/legal_agreements/terms_of_use/accept',
        method: 'POST',
      }),
      extraOptions: { handleErrors: false },
      invalidatesTags: (_, error) => (error ? [] : [ORGANIZATION_TERMS_STATUS_TAG]),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled
          dispatch(showSuccess(I18n.t('publisher.terms_of_service.accepted')))
        } catch (error) {
          const type = error?.error?.type
          const key = type === 'policy' ? 'permissions' : 'generic'
          dispatch(showError(I18n.t(`publisher.terms_of_service.accept_error.${key}`)))
        }
      },
    }),
  }),
  overrideExisting: true,
})

export const {
  useFetchOrgTermsStatusQuery,
  useRecordTermsExposureMutation,
  useAcceptTermsMutation,
} = api
